import { StaticImageData } from "next/image";
import { ItemNotFound } from "@/components/molecules/NotFound"
import { ProductCard } from "@/components/molecules/ProductCard"
import type { CommerceProduct } from "@/app/types"
import defaultImage from "@/assets/images/feature-product-image.jpg";

interface HitsSectionProps {
  hits: CommerceProduct[]
}

export function HitsSection({ hits }: HitsSectionProps) {
  if (!hits.length) return <ItemNotFound />

  return (
    <div className="grid w-full grid-cols-2 items-start gap-1 gap-y-8 sm:grid-cols-3 sm:gap-4 lg:grid-cols-2 xl:grid-cols-3">
      {hits.map((product, idx) => (
        <ProductCard
          id={product.id}
          key={product.id}
          priority={[0, 1].includes(idx)}
          {...mapProductToCardProps(product)}
        />
      ))}
    </div>
  )
}

// Helper function to map API response to ProductCard props
function mapProductToCardProps(product: CommerceProduct): Omit<CommerceProduct, "id"> & {
  featuredImage: { url: string | StaticImageData; altText: string }
  minPrice: number
  avgRating: number
  totalReviews: number
} {
  const featuredImage = {
    url: product.images[0] || defaultImage,
    altText: product.name,
  }

  const minPrice = product.price
  const avgRating = product.averageRating || 0
  const totalReviews = product.reviewCount || 0

  return {
    ...product,
    featuredImage,
    minPrice,
    avgRating,
    totalReviews,
  }
}
